import { BrowserRouter } from "react-router-dom";
import { SWRConfig } from "swr";
import { LoadingProvider } from "./context/loadingContext";
import { AppRoute } from "./routes/AppRoute";
import { ToastProvider } from "./hooks/useToast";
import { DialogProvider } from "./hooks/useDialog";
import ToastMessage from "./ui/organisms/toast/ToastMessage";
import DialogMessage from "./ui/organisms/dialog/DialogMessage";
import { HeaderTitleProvider } from "./hooks/useHeaderTitle";
import Spinner from "./ui/molecules/layouts/loading/Spinner";

function App() {
  return (
    <>
      <BrowserRouter>
        <SWRConfig
          value={{
            revalidateOnMount: true,
            revalidateOnFocus: false,
          }}
        >
          <HeaderTitleProvider>
            <LoadingProvider>
              <DialogProvider>
                <ToastProvider>
                  <ToastMessage />
                  <DialogMessage />
                  <Spinner />
                  <AppRoute />
                </ToastProvider>
              </DialogProvider>
            </LoadingProvider>
          </HeaderTitleProvider>
        </SWRConfig>
      </BrowserRouter>
    </>
  );
}

export default App;
